
<!-- header start -->
<nx-headline-box
    class="mt-2"
    [label]="'orderModule.orderOperatedRentalTaskListProtocolViewComponent.headline' | translate">
</nx-headline-box>
<!-- header end -->

<div class="bg-white">
  <!-- filter start -->
  <div class="flex flex-row pt-[0.4rem] pb-1 pl-3 pr-3 bg-white border-b">
    <div class="basis-2/3 flex flex-row gap-2">
      <!-- <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [(ngModel)] = "typesModel"
        [options]="typeOptions"
        [showClear]="true"
        placeholder="Typ"
        (onClear)="refetchTasks()"
        (onChange)="refetchTasks()"
        optionLabel="label">
          <ng-template let-option pTemplate="item">
            <div class="inline-block vertical-align-middle">
              <span class="ml-1 mt-1">{{ option.name }}</span>
            </div>
          </ng-template>
      </nx-filter-multiSelect> -->
    </div>
    <div class="basis-1/3 flex flex-row justify-end">
      <p-dropdown
        [placeholder]="'orderModule.orderOperatedRentalTaskListProtocolViewComponent.placeholder.sorting' | translate"
        [(ngModel)] = "sortModel"
        (onChange)="refetchTasks()"
        [options]="sortOptions"
        [styleClass]="'sort'"
        appendTo="body"
        optionLabel="label"
        [showClear]="false">
      </p-dropdown>
    </div>
  </div>
  <!-- filter end -->

  <!-- tasks start -->
  <div class="flex flex-col mb-[1.25rem]">
    <!--  -->
    <div
      class="border-b"
      *ngFor="let task of dataSource?.data; let isLast = last; let isFirst = first;">
      <!-- {{ task | json }} -->
      <nx-default-box
        icon="icon-control"
        [ngClass]="{'mt-[1.25rem]': !isFirst}"
        [label]="tasksService.getDueDateTime(task?.dueDateTimePeriod)" 
        class=" border-b border-[#E0E0E0] bg-[#EBEEEF]">
        {{task?.description}}
        <ng-template nxTemplate="tag">
          <p-tag 
            *ngIf="task?.protocol?.state" 
            [value]="getProtocolStateLabel(task?.protocol)"
            [severity]="getProtocolStateSeverity(task?.protocol)">
        </p-tag>
          <!-- <p-tag [value]="resourceAssignment?.getResourceAssignmentState()" [severity]="resourceAssignment?.getResourceAssignmentStateSeverity()"></p-tag> -->
        </ng-template>
      </nx-default-box>
      <app-protocol-view
        [ngClass]="{'mb-[1.25rem]': isLast}"
        [showAssignment]="false"
        [protocol]="task?.protocol">
      </app-protocol-view>
    </div>
  </div>
  <nx-empty-box
    *ngIf="!dataSource?.data || dataSource?.data?.length === 0"
    [label]="'orderModule.orderOperatedRentalTaskListProtocolViewComponent.emptyMessage' | translate">
  </nx-empty-box>
  <!-- tasks end -->

  <!-- Pagination start -->
  <p-paginator
    [dropdownAppendTo]="'body'"
    [totalRecords]="dataSource?.totalElements"
    [first]="pageModel?.pageNumber * pageModel?.pageSize"
    [rows]="pageModel?.pageSize"
    [showCurrentPageReport]="true"
    (onPageChange)="onPageChange($event)" 
    currentPageReportTemplate="{first} - {last} von {totalRecords}"
    [rowsPerPageOptions]="[5, 10]">
  </p-paginator>
  <!-- Pagination end -->
 </div>